module.exports = __webpack_public_path__ + "img/coupon.f5597932.png";